module.exports = __webpack_public_path__ + "img/HomeLogo.05211985.png";